import {
  Box,
  Flex,
  Icon,
  Text,
  VStack,
} from "@chakra-ui/react";
import {
  FaCalendar,
  FaHistory,
  FaHome,
  FaList,
  FaSignOutAlt,
  FaUserPlus
} from "react-icons/fa";
import { NavLink } from "react-router-dom";
import logo from "../../assets/dashboard/logo.png";

const getMenuItemsByRole = (role) => {
  switch (role) {
    case "admin":
      return [
        { label: "Home", icon: FaHome, path: "/dashboard" },
        { label: "Order Inventory", icon: FaHistory, path: "/dashboard/order" },
        { label: "Customers", icon: FaUserPlus, path: "/dashboard/customers" },
        { label: "Staff", icon: FaList, path: "/dashboard/staff" },
        { label: "Track", icon: FaCalendar, path: "/dashboard/trackadmin" },
        { label: "Logout", icon: FaSignOutAlt, path: "/dashboard/logout" },
      ];
    case "master":
      return [
        { label: "Home", icon: FaHome, path: "/dashboard" },
        { label: "Track", icon: FaCalendar, path: "/dashboard/track-tailor" },
        { label: "Orders", icon: FaHistory, path: "/dashboard/assigned-orders" },
        { label: "Logout", icon: FaSignOutAlt, path: "/dashboard/logout" },
      ];
    case "receptionist":
    default:
      return [
        { label: "Home", icon: FaHome, path: "/dashboard" },
        { label: "New Customer", icon: FaUserPlus, path: "/dashboard/new-customer" },
        { label: "Order History", icon: FaHistory, path: "/dashboard/order-history" },
        { label: "Master", icon: FaList, path: "/dashboard/master" },
        { label: "Track", icon: FaCalendar, path: "/dashboard/track" },
        { label: "Logout", icon: FaSignOutAlt, path: "/dashboard/logout" },
      ];
  }
};

const SharedSidebar = ({ onNavigate, variant = "desktop", role = "receptionist" }) => {
  const isMobileDrawer = variant === "mobile";
  const menuItems = getMenuItemsByRole(role);

  return (
    <Box
      w="250px"
      bg="white"
      p={4}
      h="100vh"
      overflowY="auto"
      borderRight={!isMobileDrawer ? "1px solid #ddd" : "none"}
      position={!isMobileDrawer ? "fixed" : "static"}
      top={0}
      left={0}
      zIndex={!isMobileDrawer ? 1000 : "auto"}
    >
      <Box mb={8}>
        <img src={logo} alt="Logo" width="200" />
      </Box>

      <VStack align="start" spacing={5} width="full">
        {menuItems.map(({ label, icon, path }) => (
          <NavLink
            key={label}
            to={path}
            onClick={onNavigate}
            end={path === "/dashboard"}
            style={({ isActive }) => ({
              width: "100%",
              textDecoration: "none",
              color: isActive ? "black" : "gray",
              fontWeight: isActive ? "bold" : "normal",
              background: isActive ? "#f2f2f2" : "transparent",
              borderRadius: "8px",
              padding: "8px 12px",
            })}
          >
            <Flex align="center" gap={3}>
              <Icon as={icon} />
              <Text>{label}</Text>
            </Flex>
          </NavLink>
        ))}
      </VStack>
    </Box>
  );
};

export default SharedSidebar;
